// extracted by css-extract-rspack-plugin
var _1 = "T52dKgOs5cKSvwjZ";
var _2 = "vIXsbD40LjsLecnQ";
var _3 = "arqOf6CMoxrUFQ8l";
export { _1 as "overlayStyle", _2 as "overlayStyleLight", _3 as "overlayStyleStrong" }
// extracted by css-extract-rspack-plugin
var _1 = "T52dKgOs5cKSvwjZ";
var _2 = "vIXsbD40LjsLecnQ";
var _3 = "arqOf6CMoxrUFQ8l";
export { _1 as "overlayStyle", _2 as "overlayStyleLight", _3 as "overlayStyleStrong" }
